import * as yup from 'yup';
import { z } from 'zod';
import { ACCEPTED_IMAGE_TYPES, MAX_FILE_SIZE } from '@store/constants';
import { REPORT_TYPES } from '../containers/SecurityIssues/Reports/helper';

// User Auth
export const UserSignin = yup.object().shape({
    email: yup
        .string()
        .email('Invaild Email')
        .required('Email is required')
        .matches(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
            'Please enter a valid email',
        ),
    password: yup.string().required('Password is required'),
});

export const UserEmail = yup.object().shape({
    email: yup.string().required('Email is required').email('Invaild Email'),
});

export const UserPasswordReset = yup.object().shape({
    newpassword: yup
        .string()
        .min(12)
        .max(32)
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(
            /[a-z]/,
            'Password must contain at least one lower case letter',
        )
        .matches(
            /[!@#$%^&*(),.?":{}|<>]/,
            'Password must contain at least one special character',
        )
        .matches(/[0-9]/, 'Password must contain at least one number')
        .required('New password is required'),
    reenterpassword: yup
        .string()
        .label('confirm password')
        .required('Re-enter password is required')
        .oneOf([yup.ref('newpassword'), null], 'Passwords do not match'),
});

// dashboard password change validation
export const UserPasswordChange = yup.object().shape({
    current_password: yup.string().required('Password is required'),

    new_password: yup
        .string()
        .min(12)
        .max(32)
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(
            /[a-z]/,
            'Password must contain at least one lower case letter',
        )
        .matches(
            /[!@#$%^&*(),.?":{}|<>]/,
            'Password must contain at least one special character',
        )
        .matches(/[0-9]/, 'Password must contain at least one number')
        .required('Password is required'),

    confirmPassword: yup
        .string()
        .label('confirm password')
        .required()
        .oneOf([yup.ref('new_password'), null], 'Passwords do not match'),
});

// dashboard userdetail validation
export const UserDetail = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    lastName: yup
        .string()
        .min(2, 'Last Name must contain at least two characters'),
    email: yup
        .string()
        .email('Invaild Email')
        .required('Email is required')
        .matches(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
            'Please enter a valid email',
        ),
    phone: yup
        .number()
        .required('Phone number is required')
        .min(11)
        .typeError('phone number should be a number'),
});

//(1 KB = 1024 bytes)
export const AddUserSchema = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    lastName: yup
        .string()
        .min(2, 'Last Name must contain at least two characters'),
    phoneNo: yup
        .string()
        .required('Phone number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    email: yup
        .string()
        .email('Invalid email')
        .required('email is required')
        .matches(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
            'Please enter a valid email',
        ),
    userName: yup
        .string()
        .required('Username is required')
        .max(40, 'Username max 40 characters long')
        .matches(
            /^[a-z0-9]+$/,
            'Username must contain only lowercase letters or numbers',
        ),
    eligibilityIds: yup
        .array()
        .required('eligibilty is required')
        .min(1, 'Please select atleast one eligibilty'),
    scheduleIds: yup
        .array()
        .required('schedule is required')
        .min(1, 'Please select atleast one schedule'),
    roleId: yup.string().required('role is required'),
    // unarmedExpiration: yup.date().required(),
    // armedExpiration: yup.date().notRequired(),
    // ojt: yup.date().required(),
    // annualOne: yup.date().notRequired(),
    // annualTwo: yup.date().notRequired(),
});

export const EditUserSchema = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    lastName: yup
        .string()
        .min(2, 'Last Name must contain at least two characters'),
    phoneNo: yup
        .string()
        .required('Phone number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    email: yup
        .string()
        .email('Invalid email')
        .required('email is required')
        .matches(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
            'Please enter a valid email',
        ),
    userName: yup.string().required('Username is required'),
    // .max(40, 'Username max 40 characters long')
    // .matches(
    //     /^[a-z0-9]+$/,
    //     'Username must contain only lowercase letters or numbers',
    // ),
    eligibilityIds: yup
        .array()
        .required('eligibilty is required')
        .min(1, 'Please select atleast one eligibilty'),
    scheduleIds: yup
        .array()
        .required('schedule is required')
        .min(1, 'Please select atleast one schedule'),
    roleId: yup.string().required('role is required'),
    // unarmedExpiration: yup.date().required(),
    // armedExpiration: yup.date().notRequired(),
    // ojt: yup.date().required(),
    // annualOne: yup.date().notRequired(),
    // annualTwo: yup.date().notRequired(),
});

export const AddProperty = yup.object().shape({
    name: yup
        .string()
        .required('Location Name is required')
        .min(2, 'Name must be at least 2 characters'),
    code: yup.string().required('Property Code is required'),
    companyId: yup.string().required('Client is required'),
    scheduleId: yup.string().required('Schedule is required'),
});

export const AddAddress = yup.object().shape({
    streetType: yup.string(),
    addressType: yup.string(),
    streetNumber: yup.string(),
    streetName: yup.string(),
    city: yup.string(),
    state: yup
        .string(),
        // .required('State is required')
        // .matches(/^[a-zA-Z]+$/, 'Must be only alphabets')
        // .min(2, 'Must be at least 2 characters')
        // .max(20, 'Must be at most 20 characters'),
    zip: yup
        .string()
        // .required('Zip Code is required')
        .matches(/^[0-9]+$/, 'Must be only digits'),
        // .min(5, 'Must be exactly 5 digits')
        // .max(5, 'Must be exactly 5 digits'),
    buildingNumber: yup.string(),
    longitude: yup
        .number()
        // .required('Longitude is required')
        .typeError('Longitude must be a number'),
    latitude: yup
        .number()
        // .required('Latitude is required')
        .typeError('Latitude must be a number'),
});

export const AddDocuments = yup.object().shape({
    name: yup
        .string(),
        // .required('Name is required')
        // .min(2, 'Name must be at least 2 characters'),
    accessibility: yup.string(),
    description: yup.string(),
});

export const AddLocation = yup.object().shape({
    // addressId: yup.array().required('eligibilty is required').min(1, "Please select atleast one eligibilty"),
    name: yup
        .string(),
        // .required('Name is required')
        // .min(2, 'Name must be at least 2 characters'),
    description: yup.string(),
});

export const AddIncident = yup.object().shape({
    name: yup
        .string()
        // .required('name is required')
        .min(2, 'Name must be at least 2 characters'),
    level: yup.string(),
});

export const AddCheckPoints = yup.object().shape({
    addressId: yup.string(),
    unit: yup.string(),
    propertiesIncidentTypesId: yup
        .string()
        // .required('CheckPoint incident is required'),
    // name: yup.string().required('Name is required').min(3).max(30),
    // location: yup.string().required('Location is required'),
    // code: yup.string().required('Code is required'),
    // reportNotes: yup.string().required('Report Notes is required').min(10),
    // officerNotes: yup.string().required('Officer Notes is required').min(10)
});

export const AddPhoneNumber = yup.object().shape({
    'Phone Number1': yup
        .string()
        // .required('Phone Number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                // if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    'Phone Type1': yup.string(),
    'Phone Number2': yup
        .string()
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    'Phone Number3': yup
        .string()
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    'Phone Number4': yup
        .string()
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    'Phone Number5': yup
        .string()
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
});

export const AddClient = yup.object().shape({
    name: yup
        .string()
        // .required('Name is required')
        .min(2, 'Name must be at least 2 characters'),
    url: yup
        .string()
        .notRequired()
        .test(
            'is-url',
            'Invalid URL', // Custom error message
            function (value) {
                // If the value is empty, no validation error should be thrown
                if (!value) {
                    return true;
                }
                // Regular expression to validate the URL
                const urlRegex =
                    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)*$/;
                return urlRegex.test(value);
            },
        ),
    streetNumber: yup.string(),
    streetName: yup.string().min(3).max(30),
    city: yup.string(),
    state: yup
        .string()
        // .required('State is required')
        .matches(/^[a-zA-Z]+$/, 'Must be only alphabets')
        .min(2, 'Must be at least 2 characters')
        .max(20, 'Must be at most 20 characters'),

    zip: yup
        .string()
        // .required('Zip Code is required')
        .matches(/^[0-9]+$/, 'Must be only digits')
        .min(5, 'Must be exactly 5 digits')
        .max(5, 'Must be exactly 5 digits'),
    streetType: yup.string(),
    buildingNumber: yup.string().notRequired(),
    addressType: yup.string(),
    phoneNo: yup
        .string()
        // .required('Phone Number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    fax: yup.string().notRequired(),
    note: yup.string().notRequired(),
});

export const AddGeoFence = yup.object().shape({
    name: yup
        .string()
        // .required('GeoFence is required')
        .min(2, 'Name must be at least 2 characters'),
    latitude: yup.string(),
    longitude: yup.string(),
});

export const InviteClient = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    lastName: yup
        .string()
        .min(2, 'Last Name must contain at least two characters'),
    email: yup
        .string()
        .email('Invalid email')
        .required('email is required')
        .matches(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/,
            'Please enter a valid email',
        ),
    userName: yup
        .string()
        .required('Username is required')
        // .min(3, 'Username must be at least 3 characters long')
        .max(40, 'Username max 40 characters long')
        .matches(
            /^[a-z0-9]+$/,
            'Username must contain only lowercase letters or numbers',
        ),
    phoneNo: yup
        .string()
        .required('Phone Number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    companyId: yup.string().required('Company is required'),
});

export const generateReportSchema = ({
    reportType,
    isIncidentLevelDisable = false,
}) => {
    console.log(isIncidentLevelDisable);
    const schema = {
        dates: z
            .object({
                startDate: z
                    .string({
                        required_error: 'Start date is required',
                    })
                    .date(),
                endDate: z
                    .string({
                        required_error: 'End date is required',
                    })
                    .date(),
            })
            .refine((data) => data.endDate > data.startDate, {
                message: 'End date must be later than start date',
                path: ['endDate'], // The error will be associated with the endDate field
            }),
        incidentTypeId: z
            .any()
            .refine(
                (val) =>
                    val !== undefined &&
                    val !== null &&
                    val !== '' &&
                    Array.isArray(val) &&
                    val.length > 0,
                { message: 'Issue Type is required' },
            ),
        propertyId: z.array(z.number()).min(1, {
            message: 'Property is required',
        }),
        level: isIncidentLevelDisable
            ? z.number().optional()
            : z.number({
                required_error: 'Level is required',
            }),
        status: z.string({
            required_error: 'Status is required',
        }),
        assignee: z.number({
            required_error: 'Assignee is required',
        }),
    };

    const reportSchema = {
        [REPORT_TYPES.daily]: z.object({
            dates: schema.dates,
            incidentTypeId: schema.incidentTypeId,
            propertyId: schema.propertyId,
            level: schema.level,
            status: schema.status,
        }),
        [REPORT_TYPES.compact]: z.object({
            dates: schema.dates,
            propertyId: schema.propertyId,
            status: schema.status,
        }),
        [REPORT_TYPES.grouped]: z.object({
            dates: schema.dates,
            propertyId: schema.propertyId,
            incidentTypeId: schema.incidentTypeId,
            assignee: schema.assignee,
            status: schema.status,
        }),
        [REPORT_TYPES.summary]: z.object({
            dates: schema.dates,
            propertyId: schema.propertyId,
            incidentTypeId: schema.incidentTypeId,
            level: schema.level,
            status: schema.status,
        }),
    };

    return reportSchema[reportType];
};

export const EditInviteClient = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    lastName: yup
        .string()
        .min(2, 'Last Name must contain at least two characters'),
    phoneNo: yup
        .string()
        .required('Phone Number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
    companyId: yup.string().required('Company is required'),
});
export const EditUser = yup.object().shape({
    firstName: yup
        .string()
        .min(2, 'First Name must contain at least two characters'),
    code: yup.string().min(2, 'Last Name must contain at least two characters'),
    email: z
        .string()
        .min(1, { message: 'Email Address is required' })
        .email({ message: 'Invalid email address' }),
    phone: yup
        .string()
        .required('Phone Number is required')
        .test(
            'is-valid-format',
            'Invalid phone number format',
            function (value) {
                if (!value) return true;
                return (
                    /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                    /^\d{10}$/.test(value)
                );
            },
        ),
});

export const AssignIncidentSchema = yup.object().shape({
    assignId: yup.string().required('Field is required'),
    level: yup.string().required('Field is required'),
});

export const CreateIncidentSchema = AssignIncidentSchema.shape({
    notes: yup.string().required('Field is required'),
});

export const AssignNormalShiftSchema = yup.object().shape({
    assignTo: yup.string().required('User is required'),
    break: yup.string().notRequired(),
    propertyId: yup.string().required('Property is required'),
    eligibilityId: yup.string().required('Eligibility is required'),
    notes: yup.string(),
    // locationId: yup.string().required('Location is required'),
    isPublished: yup.boolean(),
});

export const AssignOpenShiftSchema = yup.object().shape({
    break: yup.string().notRequired(),
    numberOfAssignees: yup
        .number()
        .typeError('Assignees Count must be a number')
        .integer('Assignees Count must be a whole number')
        .min(0, 'Assignees Count cannot be negative')
        .required('Assignees Count is required'),
    propertyId: yup.string().required('Property is required'),
    eligibilityId: yup.string().required('Eligibility is required'),
    // recurringFrequency: yup.string().required('Repeat Shift is required'),
    notes: yup.string(),
    // locationId: yup.string().required('Location is required'),
    isPublished: yup.boolean(),
});

export const TorRequestSchema = yup.object().shape({
    userId: yup.string().required('User is required'),
    type: yup.string().required(),
    notes: yup.string(),
});

export const OpenShiftDetail = yup.object().shape({
    usersId: yup
        .array()
        .required('user is required')
        .min(1, 'Please select atleast one user'),
});

// export const companyOnboardingSchema = {
//     0: z.object({
//         firstName: z.string().min(1, { message: 'First name is required' }),
//         lastName: z.string().min(1, { message: 'Last name is required' }),
//         email: z
//             .string()
//             .min(1, { message: 'Email Address is required' })
//             .email({ message: 'Invalid email address' }),
//         phoneNo: z.string({
//             required_error: 'Phone number is required',
//         }).refine((value) => {
//             return (
//                 /^\(\d{3}\) \d{3}-\d{4}$/.test(value) || // (123) 456-7890
//                 /^\d{10}$/.test(value)                  // 1234567890
//             );
//         }, {
//             message: 'Invalid phone number format',
//         }),
//         // .string({
//         //     required_error: 'Phone number is required',
//         // })
//         // .regex(/^\(\d{3}\) \d{3}-\d{4}$/, {
//         //     message: 'Invalid phone number',
//         // }), // Phone number regex (example for E.164 format)
//         passwords: z
//             .object({
//                 password: z
//                     .string({
//                         required_error: 'Password is required',
//                     })
//                     .min(8, {
//                         message: 'Password must be at least 8 characters',
//                     })
//                     .regex(/[a-zA-Z]/, {
//                         message: 'Password must contain at least one letter',
//                     })
//                     .regex(/\d/, {
//                         message: 'Password must contain at least one number',
//                     }),
//                 confirmPassword: z
//                     .string({
//                         required_error: 'Confirm password is required',
//                     })
//                     .min(8, {
//                         message: 'Password must be at least 8 characters',
//                     })
//                     .regex(/[a-zA-Z]/, {
//                         message: 'Password must contain at least one letter',
//                     })
//                     .regex(/\d/, {
//                         message: 'Password must contain at least one number',
//                     }),
//             })
//             .refine(
//                 ({ password, confirmPassword }) =>
//                     !password ||
//                     !confirmPassword ||
//                     password === confirmPassword,
//                 {
//                     message: 'Passwords do not match',
//                     path: ['confirmPassword'],
//                 },
//             ),
//     }),
//     1: z.object({
//         companyName: z.string().min(1, { message: 'Company name is required' }),
//         companyUrl: z
//             .string({
//                 required_error: 'Company URL is required',
//             })
//             .refine((val) => /^(?!-)[A-Za-z0-9-]{1,253}(?<!-)$|^$/.test(val), {
//                 message: 'Invalid URL format',
//             }),
//         companyEmail: z.string().email({ message: 'Invalid company email' }),
//         employeeCount: z
//             .string()
//             .refine((val) => !isNaN(parseInt(val)) && parseInt(val) > 0, {
//                 message: 'Employee count must be a positive number',
//             })
//             .transform((val) => parseInt(val)), // Convert to integer if it's valid
//     }),
//     2: z.object({
//         files: z
//             .array(z.any())
//             .min(1, { message: 'Logo is required' })
//             .refine(
//                 ([file]) => file?.size <= MAX_FILE_SIZE,
//                 `Max image size is 5MB.`,
//             )
//             .refine(
//                 ([file]) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
//                 'Only .jpg, .jpeg, .png and .webp formats are supported.',
//             ),
//         colors: z
//             .object({
//                 primary: z.string(),
//                 secondary: z.string(),
//                 text: z.string(),
//             })
//             .partial(),
//         subscriptionId: z.number({
//             required_error: 'Subscription type is required',
//         }),
//     }),
// };

export const companyOnboardingSchema = {
    0: yup.object().shape({
        firstName: yup
            .string()
            .required('First name is required')
            .matches(/[A-Za-z]/, 'First name must contain at least one letter'),

        lastName: yup
            .string()
            .required('Last name is required')
            .matches(/[A-Za-z]/, 'Last name must contain at least one letter'),

        email: yup
            .string()
            .required('Email Address is required')
            .email('Invalid email address'),

        phoneNo: yup
            .string()
            .required('Phone number is required')
            .test(
                'is-valid-format',
                'Invalid phone number format',
                function (value) {
                    return (
                        /^\(\d{3}\) \d{3}-\d{4}$/.test(value) ||
                        /^\d{10}$/.test(value)
                    );
                },
            ),

        passwords: yup.object().shape({
            password: yup
                .string()
                .min(12, 'Password must be at least 12 characters')
                .max(32, 'Password must be at most 32 characters')
                .matches(
                    /[A-Z]/,
                    'Password must contain at least one uppercase letter',
                )
                .matches(
                    /[a-z]/,
                    'Password must contain at least one lower case letter',
                )
                .matches(
                    /[!@#$%^&*(),.?":{}|<>]/,
                    'Password must contain at least one special character',
                )
                .matches(/[0-9]/, 'Password must contain at least one number')
                .required('Password is required'),
            // string()
            //     .required('Password is required')
            //     .min(8, 'Password must be at least 8 characters')
            //     .matches(/[a-zA-Z]/, 'Password must contain at least one letter')
            //     .matches(/\d/, 'Password must contain at least one number'),

            confirmPassword: yup
                .string()
                .required('Confirm password is required')
                // .min(8, 'Password must be at least 8 characters')
                // .matches(/[a-zA-Z]/, 'Password must contain at least one letter')
                // .matches(/\d/, 'Password must contain at least one number')
                .oneOf([yup.ref('password')], 'Passwords do not match'),
        }),
    }),

    1: yup.object().shape({
        companyName: yup.string().required('Company name is required'),

        companyUrl: yup
            .string()
            .required('Company URL is required')
            .test('is-valid-url', 'Invalid URL format', (val) =>
                /^(?!-)[A-Za-z0-9-]{1,253}(?<!-)$|^$/.test(val || ''),
            ),

        companyEmail: yup
            .string()
            .required('Company email is required')
            .email('Invalid company email'),

        employeeCount: yup
            .number()
            .required('Employee count is required')
            .test(
                'is-positive-number',
                'Employee count must be a positive number',
                (val) => !isNaN(Number(val)) && Number(val) > 0,
            )
            .transform((value) => (value ? parseInt(value) : undefined)),
    }),

    2: yup.object().shape({
        files: yup
            .array()
            .min(1, 'Logo is required')
            .test(
                'fileSize',
                'Max image size is 5MB.',
                ([file]) => !file || file.size <= MAX_FILE_SIZE,
            )
            .test(
                'fileFormat',
                'Only .jpg, .jpeg, .png and .webp formats are supported.',
                ([file]) => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
            ),

        colors: yup
            .object()
            .shape({
                primary: yup.string(),
                secondary: yup.string(),
                text: yup.string(),
            })
            .notRequired(), // .partial() means optional

        // holding it for now.
        // subscriptionId: yup.number()
        //     .required('Subscription type is required'),
    }),
};

export const channelCreationSchema = yup.object().shape({
    channelName: yup.string().required('Channel name is required'),
    userId: yup.array().min(1, 'At least one user is required'),
});
